export const generateCallStatusUrl = (body) => {
    const {
        lead_status,
        panel_user,
        provider,
        lead,
        qc_agent,
        start_date,
        end_date,
        direction,
        phonenumber,
        bookingId
    } = body;
    const lead_status_part = isSelectedNum(lead_status) ?
        `&lead_status=${lead_status}` :
        "";
    const panel_user_part = isSelectedNum(panel_user) ? `&panel_user=${panel_user}` : "";
    const provider_part = isSelectedNum(provider) ? `&provider=${provider}` : "";
    const lead_part = isSelectedNum(lead) ?
        `&lead=${lead}` :
        "";
    const phonenumber_part = isSelectedNum(phonenumber) ?
        `&phonenumber=${phonenumber}` :
        "";
    const booking_part = isSelectedNum(bookingId) ?
        `&bookingId=${bookingId}` :
        "";

    const qc_agent_part = isSelectedNum(qc_agent) ?
        `&quality_user=${qc_agent}` :
        "";
    const start_date_part = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const end_date_part = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const direction_part = isSelectedNum(direction) ? `&direction=${direction}` : "";

    const url = `?${lead_status_part}${panel_user_part}${provider_part}${lead_part}${qc_agent_part}${start_date_part}${end_date_part}${direction_part}${phonenumber_part}${booking_part}`;

    return url;
};

const isSelected = (field) => {
    if (
        field === "all" ||
        field === "" ||
        field === undefined ||
        field === null ||
        field === "none"
    ) {
        return false;
    } else {
        return true;
    }
};

const isSelectedNum = (field) => {
    if (field === 0 || field === "" || field === undefined || field === null || field === "none") {
        return false;
    } else {
        return true;
    }
};

export const generateCallsUrl = (body) => {
    const {
        city,
        lead_source,
        treatment,
        panel_user,
        priority,
        language,
        followup_date_start,
        followup_date_end,
        status,
        day,
    } = body;
    const city_part = isSelectedNum(city) ? `&city=${city}` : "";
    const source_part = isSelected(lead_source) ?
        `&lead_source=${lead_source}` :
        "";
    const treatment_part = isSelectedNum(treatment) ?
        `&treatment=${treatment}` :
        "";
    const panel_user_part = isSelectedNum(panel_user) ?
        `&panel_user=${panel_user}` :
        "";
    const priority_part = isSelected(priority) ? `&priority=${priority}` : "";
    const language_part = isSelected(language) ? `&language=${language}` : "";
    const followup_date_start_part = isSelected(followup_date_start) ?
        `&followup_date_start=${followup_date_start}` :
        "";
    const followup_date_end_part = isSelected(followup_date_end) ?
        `&followup_date_end=${followup_date_end}` :
        "";
    const status_part = isSelected(status) ? `&status=${status}` : "";
    const url = `?day=${day}${city_part}${source_part}${treatment_part}${panel_user_part}${priority_part}${language_part}${followup_date_start_part}${followup_date_end_part}${status_part}`;

    return url;
};

export const generateAppointmentsUrl = (body) => {
    const {
        appt_status,
        center,
        feedbackstatus,
        doctor,
        treatment,
        panel_user,
        priority,
        appt_date_start,
        appt_date_end,
        day,
        source,
        treatment_id,
        lead_id,
        feedback,
    } = body;
    const appt_status_part = isSelectedNum(appt_status) ?
        `&appt_status=${appt_status}` :
        "";
    const feedbackstatus_part = isSelectedNum(feedbackstatus) ?
        `&feedbackstatus=${feedbackstatus}` :
        "";
    const feedback_part = isSelectedNum(feedback) ?
        `&feedback=${feedback}` :
        "";
    const center_part = isSelectedNum(center) ? `&center=${center}` : "";
    const doctor_part = isSelectedNum(doctor) ? `&doctor=${doctor}` : "";
    const treatment_part = isSelectedNum(treatment) ?
        `&treatment=${treatment}` :
        "";
    const panel_user_part = isSelectedNum(panel_user) ?
        `&panel_user=${panel_user}` :
        "";
    const source_part = isSelectedNum(source) ?
        `&source=${source}` :
        "";
    const priority_part = isSelected(priority) ? `&priority=${priority}` : "";
    const appt_date_start_part = isSelected(appt_date_start) ?
        `&appt_date_start=${appt_date_start}` :
        "";
    const appt_date_end_part = isSelected(appt_date_end) ?
        `&appt_date_end=${appt_date_end}` :
        "";
    const treatment_id_part = isSelected(treatment_id) ?
        `&treatment_id=${treatment_id}` :
        "";
    const lead_id_part = isSelected(lead_id) ?
        `&lead_id=${lead_id}` :
        "";
    const day_part = isSelected(day) ? `day=${day}` : "";

    const url = `?${day_part}${appt_status_part}${center_part}${doctor_part}${treatment_part}${panel_user_part}${priority_part}${appt_date_start_part}${appt_date_end_part}${treatment_id_part}${lead_id_part}${feedback_part}${source_part}${feedbackstatus_part}`;

    return url;
};

export const generateGenomicsResearchFilterUrl = (body) => {
    const {
        name,
        email,
        mobile,
        city,
        isProjectCreated,
        inspectionStatus,
        createdAt,
        search,
        projectId,
        scientist,
        institute,
        dealer,
        project,
        runId,
        firmName,
        phase,

    } = body;
    const project_data = isSelected(project) ? `&project=${project}` : "";
    const project_donestatus = isSelected(phase) ? `&?phase=${phase}` : "";
    const dealerFirmName = isSelected(firmName) ? `&firmName=${firmName}` : "";
    const runPlan_data = isSelected(runId) ? `&?runId=${runId}` : "";
    const city_part = isSelectedNum(city) ? `&city=${city}` : "";
    const client_name = isSelectedNum(scientist) ? `&?scientist=${scientist}` : "";
    const institute_name = isSelectedNum(institute) ? `&?institute=${institute}` : "";
    const dealers_name = isSelectedNum(dealer) ? `&?dealer=${dealer}` : "";
    const project_id = isSelectedNum(projectId) ? `&?projectId=${projectId}` : "";
    const city_email = isSelectedNum(email) ? `&email=${email}` : "";
    const dealer_name = isSelectedNum(name) ? `&name=${name}` : "";
    const project_status = isSelectedNum(isProjectCreated) ? `&isProjectCreated=${isProjectCreated}` : "";
    const sample_status = isSelectedNum(inspectionStatus) ? `&inspectionStatus=${inspectionStatus}` : "";
    const date = isSelectedNum(createdAt) ? `&createdAt=${createdAt}` : "";
    const client_search = isSelectedNum(search) ? `&search=${search}` : "";
    const client_mobile = isSelected(mobile) ?
        `&mobile=${mobile}` :
        "";

    const url = `?${project_data}${project_donestatus}${dealerFirmName}${runPlan_data}${city_email}${city_part}${dealer_name}${client_mobile}${client_search}${date}${sample_status}${project_status}${project_id}${dealers_name}${institute_name}${client_name}`;

    return url;
};

export const generateGenomicsResearchUrl = (body) => {
    const {
        name,
        email,
        mobile,
        city,
        isProjectCreated,
        inspectionStatus,
        createdAt,
        search,
        projectId,
        scientist,
        institute,
        dealer,
        project,
        runId,
        firmName,
        phase,

    } = body;
    const project_data = isSelected(project) ? `&project=${project}` : "";
    const project_donestatus = isSelected(phase) ? `&phase=${phase}` : "";
    const dealerFirmName = isSelected(firmName) ? `&firmName=${firmName}` : "";
    const runPlan_data = isSelected(runId) ? `&?runId=${runId}` : "";
    const city_part = isSelectedNum(city) ? `&city=${city}` : "";
    const client_name = isSelectedNum(scientist) ? `&scientist=${scientist}` : "";
    const institute_name = isSelectedNum(institute) ? `&institute=${institute}` : "";
    const dealers_name = isSelectedNum(dealer) ? `&dealer=${dealer}` : "";
    const project_id = isSelectedNum(projectId) ? `&?projectId=${projectId}` : "";
    const city_email = isSelectedNum(email) ? `&email=${email}` : "";
    const dealer_name = isSelectedNum(name) ? `&name=${name}` : "";
    const project_status = isSelectedNum(isProjectCreated) ? `&isProjectCreated=${isProjectCreated}` : "";
    const sample_status = isSelectedNum(inspectionStatus) ? `&inspectionStatus=${inspectionStatus}` : "";
    const date = isSelectedNum(createdAt) ? `&createdAt=${createdAt}` : "";
    const client_search = isSelectedNum(search) ? `&search=${search}` : "";
    const client_mobile = isSelected(mobile) ?
        `&mobile=${mobile}` :
        "";

    const url = `?${project_data}${project_donestatus}${dealerFirmName}${runPlan_data}${city_email}${city_part}${dealer_name}${client_mobile}${client_search}${date}${sample_status}${project_status}${project_id}${dealers_name}${institute_name}${client_name}`;

    return url;
};

export const generatePositiveCallsUrl = (body) => {
    const {
        city,
        lead_source,
        treatment,
        panel_user,

        followup_date_start,
        followup_date_end,

        day,
    } = body;
    const city_part = isSelectedNum(city) ? `&city=${city}` : "";
    const source_part = isSelected(lead_source) ?
        `&lead_source=${lead_source}` :
        "";
    const treatment_part = isSelectedNum(treatment) ?
        `&treatment=${treatment}` :
        "";
    const panel_user_part = isSelectedNum(panel_user) ?
        `&panel_user=${panel_user}` :
        "";

    const followup_date_start_part = isSelected(followup_date_start) ?
        `&followup_date_start=${followup_date_start}` :
        "";
    const followup_date_end_part = isSelected(followup_date_end) ?
        `&followup_date_end=${followup_date_end}` :
        "";
    const day_part = isSelected(day) ? `day=${day}` : "";

    const url = `?${day_part}${city_part}${source_part}${treatment_part}${panel_user_part}${followup_date_start_part}${followup_date_end_part}`;

    return url;
};
export const genrateLabDetailsFilter = (body) => {
    const {
        zone,
    } = body;
    const lab_zone = isSelectedNum(zone) ? `&zone=${zone}` : "";
    const url = `?${lab_zone}`;

    return url;
};
export const genrateCenterInformationFilter = (body) => {
    const {
        city,
        area,
    } = body;
    const center_city = isSelectedNum(city) ? `&city=${city}` : "";
    const center_area = isSelectedNum(area) ? `&area=${area}` : "";
    const url = `?${center_city}${center_area}`;

    return url;
};
export const genrateCarrerFilter = (body) => {
    const {
        email,
        name,
        job_profile,
        experience,
    } = body;
    const carrer_email = isSelectedNum(email) ? `&email=${email}` : "";
    const carrer_name = isSelectedNum(name) ? `&name=${name}` : "";
    const carrer_jobProfile = isSelectedNum(job_profile) ? `&job_profile=${job_profile}` : "";
    const carrer_exprience = isSelectedNum(experience) ? `&experience=${experience}` : "";
    const url = `?${carrer_email}${carrer_name}${carrer_jobProfile}${carrer_exprience}`;
    return url;
};
export const genratePanelUserFiltr = (body) => {
    const {
        usergroup,
        is_active,
        tl,
        username,
        on_call,
        break_button
    } = body;
    const panel_usergroup = isSelectedNum(usergroup) ? `&usergroup=${usergroup}` : "";
    const panel_userStatus = isSelectedNum(is_active) ? `&is_active=${is_active}` : "";
    const panel_Break = isSelectedNum(break_button) ? `&break_button=${break_button}` : "";
    const panel_OnCall = isSelectedNum(on_call) ? `&on_call=${on_call}` : "";
    const panel_panelUser = isSelectedNum(tl) ? `&tl=${tl}` : "";
    const panel_username = isSelectedNum(username) ? `&username=${username}` : "";
    const url = `?${panel_Break}${panel_OnCall}${panel_username}${panel_usergroup}${panel_userStatus}${panel_panelUser}`;

    return url;
};


export const generateRecordingUrl = (body) => {
    const {
        lead_status,
        panel_user,
        usergroup,
        provider,
        lead,
        booking_id,
        source,
        qc_agent,
        start_date,
        end_date,
        direction,
        phonenumber,
        status,
        callToNumber,
        category,
        city,
        lead_source

    } = body;
    const lead_status_part = isSelectedNum(lead_status) ?
        `&lead_status=${lead_status}` :
        "";
    const booking_source = isSelectedNum(source) ? `&multiple_source=${source}` : "";
    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";
    const booking_call_to = isSelectedNum(callToNumber) ? `&call_to=${callToNumber}` : "";
    const lead_lead_source = isSelectedNum(lead_source) ?
        `&lead_source=${lead_source}` :
        "";
    const panel_user_part = isSelectedNum(panel_user) ? `&panel_user=${panel_user}` : "";
    const provider_part = isSelectedNum(provider) ? `&provider=${provider}` : "";
    const recording_status = isSelectedNum(status) ? `&call_picked=${status}` : "";
    const recording_category = isSelectedNum(category) ? `&category=${category}` : "";
    const usergroup_category = isSelectedNum(usergroup) ? `&usergroup=${usergroup}` : "";
    const lead_part = isSelectedNum(lead) ?
        `&lead=${lead}` :
        "";
    const booking_part = isSelectedNum(booking_id) ?
        `&booking_id=${booking_id}` :
        "";
    const phonenumber_part = isSelectedNum(phonenumber) ?
        `&phonenumber=${phonenumber}` :
        "";
    const qc_agent_part = isSelectedNum(qc_agent) ?
        `&quality_user=${qc_agent}` :
        "";
    const start_date_part = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const end_date_part = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const direction_part = isSelectedNum(direction) ? `&direction=${direction}` : "";

    const url = `?${booking_city}${booking_call_to}${booking_source}${lead_lead_source}${lead_status_part}${booking_part}${recording_category}${recording_status}${panel_user_part}${usergroup_category}${provider_part}${lead_part}${qc_agent_part}${start_date_part}${end_date_part}${direction_part}${phonenumber_part}`;

    return url;
};

export const generateBookingFilterUrl = (body) => {
    const {
        status,
        financeStatus,
        category,
        verificationStatus,
        source,
        agent,
        phlebo,
        city,
        start_date,
        end_date,
        booking_date,
        collection_date,
        name,
        lead,
        phone,
        pickupAmount,
        pickup_status,
        pickup_done,
        bookingId,
        partner,
        user_group,
        slot,
        sample_registered,
        report_status,
        is_pickup_receive_amount,
        booking_type,
        due_date,
        due_start_date,
        due_end_date,
        assigned_status,
        client_billid,
        lead_status,
        route_manager,
        verified_by,
        created_date,
        center_type,
        mobile,
        tl,
    } = body;
    console.log(body, "lead")
    const booking_category = (isSelectedNum(category) && category !== "0") ? `&multiple_disposition=${category}` : "";
    const booking_status = isSelectedNum(status) ?
        `&multiple_booking_status=${status}` :
        "";
    const center = isSelectedNum(center_type) ?
        `&center=${center_type}` :
        "";
    const mobile_number = isSelectedNum(mobile) ?
        `&center=${mobile}` :
        "";
    const booking_category_status = isSelectedNum(lead_status) ?
        `&multiple_category=${lead_status}` :
        "";
    const booking_id = isSelectedNum(bookingId) ?
        `&booking_id=${bookingId}` :
        "";
    const booking_verified_by = isSelectedNum(verified_by) ?
        `&verified_by=${verified_by}` :
        "";
    const booking_routemanager = isSelectedNum(route_manager) ?
        `&route_manager=${route_manager}` :
        "";
    const booking_client_billid = isSelectedNum(client_billid) ?
        `&client_billid=${client_billid}` :
        "";
    const booking_lead_id = isSelectedNum(lead) ?
        `&lead=${lead}` :
        "";
    const booking_partner = isSelectedNum(partner) ?
        `&multiple_partner=${partner}` :
        "";
    const booking_user_group = isSelectedNum(user_group) ?
        `&multiple_usergroup=${user_group}` :
        "";
    const verification_status = isSelectedNum(verificationStatus) ?
        `&multiple_verification_status=${verificationStatus}` :
        "";
    const booking_source = isSelectedNum(source) ? `&multiple_source=${source}` : "";
    const booking_agent = isSelectedNum(agent) ?
        `&multiple_agent=${agent}` :
        "";
    const booking_phlebo = isSelectedNum(phlebo) ?
        `&multiple_phlebo=${phlebo}` :
        "";

    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";
    const booking_collection_slots = isSelectedNum(slot) ? `&multiple_collection_slots=${slot}` : "";
    const booking_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const booking_booking_date = isSelected(booking_date) ? `&booking_date=${booking_date}` : "";
    const booking_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const booking_tl = isSelected(tl) ? `&tl=${tl}` : "";
    const booking_end_date = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const booking_due_date = isSelected(due_date) ?
        `&due_date=${due_date}` :
        "";
    const booking_due_start_date = isSelected(due_start_date) ?
        `&due_start_date=${due_start_date}` :
        "";
    const booking_due_end_date = isSelected(due_end_date) ?
        `&due_end_date=${due_end_date}` :
        "";
    const booking_collection_date = isSelected(collection_date) ?
        `&collection_date=${collection_date}` :
        "";
    const booking_name = isSelectedNum(name) ? `&name=${name}` : "";
    const booking_phone = isSelectedNum(phone) ? `&phone=${phone}` : "";
    const booking_pickup_status = isSelectedNum(pickup_status) ? `&multiple_pickup_status=${pickup_status}` : "";
    const booking_pickup_done = isSelectedNum(pickup_done) ? `&pickup_done=${pickup_done}` : "";
    const booking_pickup_amount = isSelectedNum(pickupAmount) ? `&pickup_amount=${pickupAmount}` : "";
    const booking_finance_status = isSelectedNum(financeStatus) ? `&multiple_finance_status=${financeStatus}` : "";
    const booking_booking_type = isSelectedNum(booking_type) ? `&booking_type=${booking_type}` : "";
    const booking_sample_registered = isSelectedNum(sample_registered) ? `&sample_registered=${sample_registered}` : "";
    const booking_report_status = isSelectedNum(report_status) ? `&multiple_report_status=${report_status}` : "";
    const booking_is_pickup_receive_amount = isSelectedNum(is_pickup_receive_amount) ? `&is_pickup_receive_amount=${is_pickup_receive_amount}` : "";
    const assignedStatus = isSelected(assigned_status) ? `&assigned_status=${assigned_status}` : "";
    const url = `?${booking_verified_by}${mobile_number}${booking_routemanager}${booking_category_status}${booking_client_billid}${booking_tl}${booking_due_date}${booking_due_start_date}${booking_due_end_date}${booking_booking_type}${booking_is_pickup_receive_amount}${center}${booking_report_status}${booking_sample_registered}${booking_user_group}${booking_collection_slots}${booking_finance_status}${booking_category}${booking_id}${booking_pickup_done}${booking_partner}${booking_pickup_status}${booking_pickup_amount}${booking_agent}${booking_name}${booking_phone}${booking_phlebo}${booking_city}${booking_source}${booking_start_date}${booking_end_date}${booking_collection_date}${booking_status}${booking_booking_date}${verification_status}${booking_lead_id}${assignedStatus}`;
    // const url = `?${booking_routemanager}${booking_category_status}${booking_client_billid}${booking_tl}${booking_due_date}${booking_due_start_date}${booking_due_end_date}${booking_created_date}${booking_booking_type}${booking_is_pickup_receive_amount}${booking_report_status}${booking_sample_registered}${booking_user_group}${booking_collection_slots}${booking_finance_status}${booking_category}${booking_id}${booking_pickup_done}${booking_partner}${booking_pickup_status}${booking_pickup_amount}${booking_agent}${booking_name}${booking_phone}${booking_phlebo}${booking_city}${booking_source}${booking_start_date}${booking_end_date}${booking_collection_date}${booking_status}${booking_booking_date}${verification_status}${booking_lead_id}${assignedStatus}`;
    return url;
};
export const genrateCollectionCentrLedgerFilter = (body) => {
    const {
        status,
        center,
        start_date,
        end_date,
        ledger_type
    } = body;
    const collection_center = isSelectedNum(center) ?
        `&multiple_center=${center}` :
        "";
    const collection_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const collection_end_date = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const collection_status = isSelectedNum(status) ? `&status=${status}` : "";
    const collection_ledger_type = isSelectedNum(ledger_type) ? `&ledger_type=${ledger_type}` : "";
    const url = `?${collection_start_date}${collection_end_date}${collection_status}${collection_ledger_type}${collection_center}`;
    return url;
};
export const genrateRepeatedListFilter = (body) => {
    const {
        lead,
        start_date,
        end_date,
        created_at,
    } = body;
    const repeated_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const repeated_end_date = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const repeated_lead = isSelectedNum(lead) ?
        `&lead=${lead}` :
        "";
    const repeated_created_at = isSelected(created_at) ? `&created_date=${created_at}` : "";
    const url = `?${repeated_start_date}${repeated_end_date}${repeated_lead}${repeated_created_at}`;
    return url;
};
export const genrateSampleHandoverFilter = (body) => {
    const {
        start_date,
        end_date,
        created_date,
        phlebo,
        booking,
        rider,
        id,
        barcode,
        batchStatus,
        // city
    } = body;
    const sampleHandover_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    // const booking_city = isSelectedNum(city) ? `&city=${city}` : "";
    const sampleHandover_barcode = isSelected(barcode) ? `&barcode=${barcode}` : "";
    const sampleHandover_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";
    const sampleHandover_created_at = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const sampleHandover_phlebo = isSelectedNum(phlebo) ? `&phlebo=${phlebo}` : "";
    const sampleHandover_rider = isSelectedNum(rider) ? `&rider=${rider}` : "";
    const sampleHandover_rider_id = isSelectedNum(id) ? `&id=${id}` : "";
    const sampleHandover_booking_id = isSelectedNum(booking) ? `&booking=${booking}` : "";
    const batch_status = isSelectedNum(batchStatus) ? `&batch_status=${batchStatus}` : "";
    const url = `?${sampleHandover_barcode}${sampleHandover_rider_id}${sampleHandover_booking_id}${sampleHandover_start_date}${sampleHandover_end_date}${sampleHandover_created_at}${sampleHandover_phlebo}${sampleHandover_rider}${batch_status}`;
    return url;
};
export const genrateUnUploadedBookingFilter = (body) => {
    const {
        start_date,
        end_date,
        created_date,
    } = body;
    const sampleHandover_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const sampleHandover_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";
    const sampleHandover_created_at = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const url = `?${sampleHandover_start_date}${sampleHandover_end_date}${sampleHandover_created_at}`;
    return url;
};
export const generateVerifiedBookingFilterUrl = (body) => {
    const {
        status,
        financeStatus,
        category,
        verificationStatus,
        source,
        agent,
        phlebo,
        city,
        start_date,
        end_date,
        booking_date,
        collection_date,
        name,
        phone,
        pickupAmount,
        pickup_status,
        pickup_done,
        bookingId,
        partner,
        user_group,
        slot,
        sample_registered,
        report_status,
        is_pickup_receive_amount,
        type
    } = body;
    const booking_category = (isSelectedNum(category) && category !== "0") ? `&multiple_disposition=${category}` : "";
    const booking_status = isSelectedNum(status) ?
        `&multiple_booking_status=${status}` :
        "";
    const booking_id = isSelectedNum(bookingId) ?
        `&booking=${bookingId}` :
        "";
    const booking_partner = isSelectedNum(partner) ?
        `&multiple_partner=${partner}` :
        "";
    const booking_user_group = isSelectedNum(user_group) ?
        `&multiple_usergroup=${user_group}` :
        "";
    const verification_status = isSelectedNum(verificationStatus) ?
        `&multiple_verification_status=${verificationStatus}` :
        "";
    const booking_source = isSelectedNum(source) ? `&multiple_source=${source}` : "";
    const booking_agent = isSelectedNum(agent) ?
        `&multiple_agent=${agent}` :
        "";
    const booking_phlebo = isSelectedNum(phlebo) ?
        `&multiple_phlebo=${phlebo}` :
        "";

    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";
    const booking_collection_slots = isSelectedNum(slot) ? `&multiple_collection_slots=${slot}` : "";
    const booking_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const booking_booking_date = isSelected(booking_date) ? `&booking_date=${booking_date}` : "";
    const booking_end_date = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const booking_collection_date = isSelected(collection_date) ?
        `&collection_date=${collection_date}` :
        "";
    const booking_name = isSelectedNum(name) ? `&name=${name}` : "";
    const booking_type = isSelectedNum(type) ? `&type=${type}` : "";
    const booking_phone = isSelectedNum(phone) ? `&phone=${phone}` : "";
    const booking_pickup_status = isSelectedNum(pickup_status) ? `&multiple_pickup_status=${pickup_status}` : "";
    const booking_pickup_done = isSelectedNum(pickup_done) ? `&pickup_done=${pickup_done}` : "";
    const booking_pickup_amount = isSelectedNum(pickupAmount) ? `&pickup_amount=${pickupAmount}` : "";
    const booking_finance_status = isSelectedNum(financeStatus) ? `&multiple_finance_status=${financeStatus}` : "";
    const booking_sample_registered = isSelectedNum(sample_registered) ? `&sample_registered=${sample_registered}` : "";
    const booking_report_status = isSelectedNum(report_status) ? `&multiple_report_status=${report_status}` : "";
    const booking_is_pickup_receive_amount = isSelectedNum(is_pickup_receive_amount) ? `&is_pickup_receive_amount=${is_pickup_receive_amount}` : "";
    const url = `?${booking_type}${booking_is_pickup_receive_amount}${booking_report_status}${booking_sample_registered}${booking_user_group}${booking_collection_slots}${booking_finance_status}${booking_category}${booking_id}${booking_pickup_done}${booking_partner}${booking_pickup_status}${booking_pickup_amount}${booking_agent}${booking_name}${booking_phone}${booking_phlebo}${booking_city}${booking_source}${booking_start_date}${booking_end_date}${booking_collection_date}${booking_status}${booking_booking_date}${verification_status}`;
    return url;
};
export const generateLeadsUrl = (body) => {
    const {
        category,
        start_date,
        end_date,
        createdAt,
        followUpDate,
        leadSource,
        priority,
        city,
        agent,
        phone,
        id,
        tl,
        lead_form_call
    } = body;
    const leads_panelUser = isSelectedNum(tl) ? `&tl=${tl}` : "";
    const leads_lead_form_call = isSelectedNum(lead_form_call) ? `&lead_form_call=${lead_form_call}` : "";
    const leads_created_date = isSelected(createdAt) ? `&created_date=${createdAt}` : "";
    const leads_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const leads_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";
    const leads_followUpDate = isSelected(followUpDate) ? `&followup_date=${followUpDate}` : "";
    const leads_phone = isSelected(phone) ? `&phone=${phone}` : "";
    const leads_lead_source = isSelected(leadSource) ? `&multiple_lead_source=${leadSource}` : "";
    const leads_priority = isSelected(priority) ? `&multiple_priority=${priority}` : "";
    const leads_id = isSelected(id) ? `&id=${id}` : "";
    const leads_category = (isSelectedNum(category) && category !== "0") ? `&multiple_category=${category}` : "";
    const leads_city = (isSelectedNum(city)) ? `&multiple_city=${city}` : "";
    const leads_agent = (isSelectedNum(agent)) ? `&multiple_agent=${agent}` : "";

    const url = `?${leads_lead_form_call}${leads_panelUser}${leads_phone}${leads_category}${leads_agent}${leads_start_date}${leads_end_date}${leads_city}${leads_id}${leads_created_date}${leads_followUpDate}${leads_lead_source}${leads_priority}`;

    return url;
};
export const generateRCFreshsUrl = (body) => {
    const {
        category,
        start_date,
        end_date,
        createdAt,
        followUpDate,
        leadSource,
        priority,
        city,
        agent,
        phone,
        id
    } = body;
    const leads_created_date = isSelected(createdAt) ? `&created_date=${createdAt}` : "";
    const leads_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const leads_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";
    const leads_followUpDate = isSelected(followUpDate) ? `&followup_date=${followUpDate}` : "";
    const leads_phone = isSelected(phone) ? `&phone=${phone}` : "";
    const leads_lead_source = isSelected(leadSource) ? `&multiple_lead_source=${leadSource}` : "";
    const leads_priority = isSelected(priority) ? `&multiple_priority=${priority}` : "";
    const leads_id = isSelected(id) ? `&lead_id=${id}` : "";
    const leads_category = (isSelectedNum(category) && category !== "0") ? `&multiple_category=${category}` : "";
    const leads_city = (isSelectedNum(city)) ? `&multiple_city=${city}` : "";
    const leads_agent = (isSelectedNum(agent)) ? `&multiple_agent=${agent}` : "";

    const url = `?${leads_phone}${leads_category}${leads_agent}${leads_start_date}${leads_end_date}${leads_city}${leads_id}${leads_created_date}${leads_followUpDate}${leads_lead_source}${leads_priority}`;

    return url;
};

export const generateCallRecordingUrl = (body) => {
    const {
        status,
        lead,
        created_date,
        direction,
    } = body;
    const call_status = isSelectedNum(status) ?
        `&call_picked=${status}` :
        "";
    const call_lead = isSelectedNum(lead) ?
        `&lead=${lead}` :
        "";
    const call_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const direction_part = isSelectedNum(direction) ? `&direction=${direction}` : "";
    const url = `?${call_status}${call_lead}${call_created_date}${direction_part}`;
    return url;
};

export const generateWhatsappMessageUrl = (body) => {
    const {
        start_date,
        lead,
        created_date,
        end_date,
        panel_user,
        type
    } = body;
    const whatsapp_start_date = isSelectedNum(start_date) ?
        `&start_date=${start_date}` :
        "";
    const whatsapp_lead = isSelectedNum(lead) ?
        `&lead=${lead}` :
        "";
    const whatsapp_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const whatsapp_end_date = isSelectedNum(end_date) ? `&end_date=${end_date}` : "";
    const whatsapp_panel_user = isSelectedNum(panel_user) ? `&panel_user=${panel_user}` : "";
    const whatsapp_type = isSelectedNum(type) ? `&type=${type}` : "";
    const url = `?${whatsapp_type}${whatsapp_panel_user}${whatsapp_start_date}${whatsapp_lead}${whatsapp_created_date}${whatsapp_end_date}`;
    return url;
};

export const generateDispositionUrl = (body) => {
    const {
        category,
        city,
        agent,
        start_date,
        end_date,
        created_date
    } = body;

    const leads_category = (isSelectedNum(category) && category !== "0") ? `&multiple_disposition=${category}` : "";
    const leads_city = (isSelectedNum(city)) ? `&multiple_city=${city}` : "";
    const leads_agent = (isSelectedNum(agent)) ? `&multiple_agent=${agent}` : "";
    const leads_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const leads_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const leads_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";

    const url = `?${leads_category}${leads_agent}${leads_city}${leads_created_date}${leads_start_date}${leads_end_date}`;

    return url;
};
export const getCenterFilter = (body) => {
    const {
        centre_type_id,
        id,
    } = body;
    const center_center = (isSelectedNum(centre_type_id)) ? `&centre_type_id=${centre_type_id}` : "";
    const center_center_type = (isSelectedNum(id)) ? `&id=${id}` : "";

    const url = `?${center_center}${center_center_type}`;

    return url;
};
export const generateBookingDispositionUrl = (body) => {
    const {
        category,
        city,
        agent,
        start_date,
        end_date,
        created_date,
        userGroup,
    } = body;

    const leads_category = (isSelectedNum(category) && category !== "0") ? `&multiple_disposition=${category}` : "";
    const leads_city = (isSelectedNum(city)) ? `&multiple_city=${city}` : "";
    const leads_agent = (isSelectedNum(agent)) ? `&multiple_agent=${agent}` : "";
    const leads_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const leads_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const leads_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";
    const leads_usergroup = isSelected(userGroup) ? `&usergroup=${userGroup}` : "";

    const url = `?${leads_usergroup}${leads_category}${leads_agent}${leads_city}${leads_created_date}${leads_start_date}${leads_end_date}`;

    return url;
};
export const generateAttendenceFilterUrl = (body) => {
    const {
        phlebo,
        start_date,
        end_date,
        created_date,
    } = body;
    const attendence_phlebo = isSelectedNum(phlebo) ?
        `&multiple_phlebo=${phlebo}` :
        "";
    const attendence_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const attendence_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const attendence_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";

    const url = `?${attendence_phlebo}${attendence_start_date}${attendence_end_date}${attendence_created_date}`;

    return url;
};
export const generateCxFilterUrl = (body) => {
    const {
        status,
        verificationStatus,
        phlebo,
        city,
        start_date,
        end_date,
        booking_date,
        collection_date,
        name,
        phone,
        pickup_status,
    } = body;
    const booking_status = isSelectedNum(status) ?
        `&multiple_booking_status=${status}` :
        "";
    const booking_phlebo = isSelectedNum(phlebo) ?
        `&multiple_phlebo=${phlebo}` :
        "";
    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";
    const booking_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const booking_booking_date = isSelected(booking_date) ? `&booking_date=${booking_date}` : "";
    const booking_end_date = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const booking_collection_date = isSelected(collection_date) ?
        `&collection_date=${collection_date}` :
        "";
    const booking_name = isSelectedNum(name) ? `&name=${name}` : "";
    const booking_phone = isSelectedNum(phone) ? `&phone=${phone}` : "";
    const booking_pickup_status = isSelectedNum(pickup_status) ? `&multiple_pickup_status=${pickup_status}` : "";
    const verification_status = isSelectedNum(verificationStatus) ? `&multiple_verification_status=${verificationStatus}` : "";

    const url = `?${booking_pickup_status}${booking_name}${booking_phone}${booking_phlebo}${booking_city}${booking_start_date}${booking_end_date}${booking_collection_date}${booking_status}${verification_status}${booking_booking_date}`;

    return url;
};
export const generateQueryTicketBookingFilterUrl = (body) => {
    const {
        bookingId,
        ticket_Status,
        query_type,
        created_date,
        start_date,
        end_date,
    } = body;
    const booking_ticket_Status = isSelectedNum(ticket_Status) ?
        `&multiple_ticket_status=${ticket_Status}` :
        "";
    const booking_id = isSelectedNum(bookingId) ?
        `&booking_id=${bookingId}` :
        "";
    const booking_query_type = isSelectedNum(query_type) ?
        `&multiple_querytype=${query_type}` :
        "";
    const booking_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const booking_end_date = isSelected(end_date) ?
        `&end_date=${end_date}` :
        "";
    const booking_created_date = isSelected(created_date) ?
        `&created_date=${created_date}` :
        "";

    const url = `?${booking_query_type}${booking_ticket_Status}${booking_id}${booking_start_date}${booking_end_date}${booking_created_date}`;

    return url;
};
export const generateCurrentDayBookingFilterUrl = (body) => {
    const {
        city,
        booking_date,
        collection_date,
    } = body;
    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";
    const booking_booking_date = isSelected(booking_date) ? `&booking_date=${booking_date}` : "";
    const booking_collection_date = isSelected(collection_date) ?
        `&collection_date=${collection_date}` :
        "";
    const url = `?${booking_city}${booking_collection_date}${booking_booking_date}`;

    return url;
};
export const generateCityWisePhlebosFilterUrl = (body) => {
    const {
        city,
    } = body;
    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";

    const url = `?${booking_city}`;

    return url;
};
export const generateSmsFilterUrl = (body) => {
    const {
        booking,
        phonenumber,
    } = body;
    const booking_id = isSelectedNum(booking) ?
        `&booking=${booking}` :
        "";
    const booking_phone = isSelectedNum(phonenumber) ? `&phonenumber=${phonenumber}` : "";
    const url = `?${booking_id}${booking_phone}`;

    return url;
};
export const generateEmailFilterUrl = (body) => {
    const {
        booking,
        email,
    } = body;
    const booking_id = isSelectedNum(booking) ?
        `&booking=${booking}` :
        "";
    const booking_email = isSelectedNum(email) ? `&email=${email}` : "";
    const url = `?${booking_id}${booking_email}`;

    return url;
};
export const generatePincodeFilterUrl = (body) => {
    const {
        city,
        pincode,
    } = body;
    const booking_city = isSelectedNum(city) ? `&multiple_city=${city}` : "";
    const booking_pincode = isSelected(pincode) ? `&search=${pincode}` : "";
    const url = `?${booking_city}${booking_pincode}`;

    return url;
};
export const generateBreakUrl = (body) => {
    const {
        agent,
        start_date,
        end_date,
        created_date
    } = body;

    const leads_agent = (isSelectedNum(agent)) ? `&panel_user=${agent}` : "";
    const leads_created_date = isSelected(created_date) ? `&created_date=${created_date}` : "";
    const leads_start_date = isSelected(start_date) ? `&start_date=${start_date}` : "";
    const leads_end_date = isSelected(end_date) ? `&end_date=${end_date}` : "";

    const url = `?${leads_agent}${leads_created_date}${leads_start_date}${leads_end_date}`;

    return url;
};

export const generateCityPriceFilter = (body) => {
    const {
        city,
        package_id,
    } = body;
    const cityPrice_city = isSelectedNum(city) ? `&city=${city}` : "";
    const cityPrice_package = isSelectedNum(package_id) ? `&package_id=${package_id}` : "";

    const url = `?${cityPrice_city}${cityPrice_package}`;

    return url;
};

export const generateBlockedCardFilter = (body) => {
    const {
        package_id,
        Zone,
    } = body;
    const blockedCard_package = isSelectedNum(package_id) ? `&package_id=${package_id}` : "";
    const blockedCard_Zone = isSelectedNum(Zone) ? `&Zone=${Zone}` : "";

    const url = `?${blockedCard_Zone}${blockedCard_package}`;

    return url;
};
export const genrateUnregisterdBookingFilter = (body) => {
    const {
        multiple_booking
    } = body;
    const unregisterd_bookingId = isSelectedNum(multiple_booking) ? `&multiple_booking=${multiple_booking}` : "";
    const url = `?${unregisterd_bookingId}`;

    return url;
};